import React from "react";
import { Form, FormGroup, Label, Input } from "reactstrap";
import './Add-People.css'

const Renderinputfields = (props) => {
    return (
        <div className='add-people'>
            <Form>
                {props.inputFields.map((modalInput, index) => {
                    return (
                        <FormGroup key={index}>
                            <Input
                                placeholder="Enter an email Id"
                                type={modalInput.inputType}
                                name={modalInput.name}
                                // id={`email-${index}`}
                            />
                            {/* <span id={`error-${index}`}></span> */}
                        </FormGroup>
                    )
                })}
                <div className="add-people-button-wrapper">
                    <FormGroup check>
                        <Label check>
                            <Input
                                type="checkbox"
                                checked={props.isChecked}
                                onChange={props.handleInputFields}
                            />
                            ADD ANOTHER
                        </Label>
                    </FormGroup>
                    <input type='submit' className="submit" />
                </div>
            </Form>
        </div>
    );
};

export default Renderinputfields;



// WEBPACK FOOTER //
// ./src/new/Dashboard/Admin/Manage-WorkSheet/Add-People-Modal/Add-People.jsx